import { useEffect, useState } from "react";
import { useGetClocksErrors } from "../hooks/useGetClocksErrors";
import DSBox from "views/system-design/DSBox";
import DSTabs from "views/system-design/DSTabs";
import DSTab from "views/system-design/DSTab";
import LogFilters from "./LogsFilters";
import ErrorsStats from "./ErrorsStats";
import ErrorsTable from "./ErrorsTable";
import IgnoredErrorsTab from "./IgnoredErrorsTab";
import firebaseService from "firebase_service/firebaseService";

const ErrorsDashboard = () => {
  const [fromVersion, setFromVersion] = useState<number | null>(
    firebaseService.general?.public ?? null,
  );
  const [toVersion, setToVersion] = useState<number | null>(
    firebaseService.general?.last ?? null,
  );
  const [specificVersion, setSpecificVersion] = useState<number | null>(null);

  useEffect(() => {
    if (fromVersion != null && toVersion != null) return;
    const unsubscribe = firebaseService.db
      .collection("general")
      .doc("config")
      .onSnapshot((snap) => {
        const data = snap.data();
        if (fromVersion == null && data?.public) setFromVersion(data.public);
        if (toVersion == null && data?.last) setToVersion(data.last);
      });
    return unsubscribe;
  }, []);

  const queryFromVersion =
    specificVersion != null ? specificVersion : fromVersion;
  const queryToVersion = specificVersion != null ? specificVersion : toVersion;

  const { data, isLoading } = useGetClocksErrors(
    queryFromVersion,
    queryToVersion,
  );

  return (
    <DSBox>
      <LogFilters
        fromVersion={fromVersion}
        setFromVersion={setFromVersion}
        toVersion={toVersion}
        setToVersion={setToVersion}
        specificVersion={specificVersion}
        setSpecificVersion={setSpecificVersion}
      />

      <ErrorsStats logs={data ?? []} isLoading={isLoading} />
    </DSBox>
  );
};

const ClocksMonitor = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <DSBox>
      <DSTabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
      >
        <DSTab label="Dashboard" />
        <DSTab label="Monitor" />
        <DSTab label="Ignored Errors" />
      </DSTabs>
      {activeTab === 0 && <ErrorsDashboard />}
      {activeTab === 1 && (
        <DSBox sx={{ p: 3 }}>
          <ErrorsTable />
        </DSBox>
      )}
      {activeTab === 2 && <IgnoredErrorsTab />}
    </DSBox>
  );
};
export default ClocksMonitor;
